import * as React from 'react'
import './style.less'
import {Button} from 'telstra-ui/components/button/Button'
import {Pictograms} from 'telstra-ui/components/svg/Pictograms'
import {useNavigate} from 'react-router-dom'

const MapMarkerError = ({onTryAgain}) => {
  const navigate = useNavigate()

  const onReportAnError = () => {
    navigate('/app/support/error-report')
  }

  return (
    <div className="tc-np-map-marker-error-container">
      <div className="tc-np-inner-container">
        <div className="tc-np-description-container">
          <summary className="heading16 summary">Something went wrong</summary>
          <div className="description">If this problem persists you can report an error</div>
        </div>
        <Pictograms name="picto-error" className="picto-error" />
      </div>
      <div className="button-container">
        <Button variant="primary" size="small" onClick={onReportAnError}>
          Report an error
        </Button>
        <Button
          variant="primary"
          size="small"
          iconPosition="left"
          icon="icon-system-retry"
          onClick={onTryAgain}
        >
          Try again
        </Button>
      </div>
    </div>
  )
}

export {MapMarkerError}
